import { GetterTree } from 'vuex';
import { I18nState } from './state';

export enum I18nGetterTypes {
  GET_LOCALES = 'GET_LOCALES'
}

export const getters: GetterTree<I18nState, {}> = {
  [I18nGetterTypes.GET_LOCALES]: (state) => {
    return Object.keys(state.messages);
  }
};
